<template>
  <div class="card card-info">
    <div class="card-header with-border">
      <div class="card-title">
        <h3>Department Coordinator</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <b>Enter Student Roll #</b>
          <div class="input-group input-group-sm">
            <input type="text" class="form-control" v-model="rollNum" v-mask="'#######'">
            <span class="input-group-append">
              <button class="btn btn-info btn-flat" type="button" v-on:click="loadTranscript()">Search</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return { 
        rollNum: '', 
      }
    },

    methods: { 

      loadTranscript() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/gettransciptdata?rollno=' + vm.rollNum)
          .then(function (res) {
            if (!res.data.status) {
              toastr.error("No Student Found", "Error!");
              endReq();
            }
            else {
              window.location = "/DC/TranscriptPrint";
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
       


    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/transcript.vue